module.exports = __webpack_public_path__ + "static/media/adresse.8e791a40.png";